module.exports = __webpack_public_path__ + "img/andaxin.a5ec62e0.jpg";